
/**
 * PDF 閱讀進度儲存模組
 * 使用 localStorage 記錄每個 PDF 的最後閱讀頁數
 */

const STORAGE_KEY_PREFIX = 'pdf-reading-progress-';

/**
 * 儲存PDF閱讀進度
 * @param pdfUrl - PDF 檔案的網址或路徑
 * @param pageNumber - 目前閱讀的頁碼
 */
export const saveReadingProgress = (pdfUrl: string, pageNumber: number): void => {
  try {
    const key = `${STORAGE_KEY_PREFIX}${pdfUrl}`;
    localStorage.setItem(key, pageNumber.toString());
  } catch (error) {
    console.error('Failed to save reading progress:', error);
  }
};

/**
 * 載入PDF閱讀進度
 * @param pdfUrl - PDF 檔案的網址或路徑
 * @returns 最後閱讀的頁碼，若沒有記錄則回傳 null
 */
export const loadReadingProgress = (pdfUrl: string): number | null => {
  try {
    const key = `${STORAGE_KEY_PREFIX}${pdfUrl}`;
    const saved = localStorage.getItem(key);
    return saved ? parseInt(saved, 10) : null;
  } catch (error) {
    console.error('載入載入PDF閱讀進度失敗');
    return null;
  }
};